import { render, staticRenderFns } from "./service.vue?vue&type=template&id=45b58382&scoped=true&"
import script from "./service.vue?vue&type=script&lang=js&"
export * from "./service.vue?vue&type=script&lang=js&"
import style0 from "./service.vue?vue&type=style&index=0&id=45b58382&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b58382",
  null
  
)

export default component.exports